<template >
  <div class="oc-component-body">
    <div class="oc-unsubscribe-box">
      <img src="@/assets/oneclose_logo.png" class="oc-image" style="float: right"/>
      <h3 class="text-blue">Unsubscribe</h3>
      <br>
      <br>
      Thank You for reaching out.
      <br>
      Your email address <strong>{{this.emailAddress}}</strong> has been successfully unsubscribed from our email list.
      <br>
      <br>
      If you ever need to reach us for any reason, please call <strong>1-CLOSE</strong><a class="text-blue" href="tel:18665125673"><u>(1-866-512-5673)</u>
    </a>
    </div>
  </div>

</template>

<script>
    import axios from 'axios';

    export default {


        name: 'Unsubscribe',
        components:{
        },
        data() {
            return {
            emailAddress:"",
            }
        },
        computed:{
            environmentVariable:{
                get(){
                    if(this.$route.query.env){
                        return this.$route.query.env;
                    }
                    return "";
                }
            },
            baseApiURL:{
                get(){
                    if(this.environmentVariable == "dev"){
                        return process.env.VUE_APP_API_BASE_DEV
                    }
                    if(this.environmentVariable == "staging"){
                        return process.env.VUE_APP_API_BASE_STAGING
                    }
                    if(this.environmentVariable == "prod"){
                        return process.env.VUE_APP_API_BASE_PROD
                    }
                    if(this.environmentVariable == "test"){
                        return process.env.VUE_APP_API_BASE_TEST
                    }
                    else {
                        return "";
                    }
                }
            },
        },
        methods:{
            sendUnsubscribedEmailDetail(purchaserToken){
                axios.get("/restrictedEmail?client="+ purchaserToken,{
                    baseURL: this.baseApiURL,
                    params: {},
                    headers:{
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type, Authorization, Content-Length, X-Requested-With,Oci-User',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS'
                    }
                })
                    .then(r => r.data)
                    .then(data => {
                        // console.log(data)
                    })
                    .catch(function (error) {
                        // console.log(error);
                    });
            },
            getTemplate(purchaserToken){
                axios.get("/campaign/templateData?client="+ purchaserToken,{
                    baseURL: this.baseApiURL,
                    params: {},
                    headers:{
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'X-PINGOTHER, Content-Type, Authorization, Content-Length, X-Requested-With,Oci-User',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS'
                    }
                })
                    .then(r => r.data)
                    .then(data => {
                        var wealthSaverObj = JSON.parse(data.artifact);
                        this.emailAddress = wealthSaverObj.emailAddress;
                    })
                    .catch(function (error) {
                        // console.log(error);
                    });
            }
        },
        created(){
            this.sendUnsubscribedEmailDetail(this.$route.query.client);
            this.getTemplate(this.$route.query.client);
        },
    }
</script>

<style scoped>
  .oc-component-body{
    background-color: whitesmoke;
    top: 0px;
    padding: 0px 0px 0px 0px;
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100vh;
    /*position: relative;*/


  }
  .oc-image{
    width: auto;
    height:30px;
  }
  .oc-unsubscribe-box{
    background-color: white;
    padding: 50px 50px 50px 50px;
    margin: 150px 150px  150px 450px;
    border-radius: 6px;
    position: absolute;
    display: block;

  }
  @media (max-width: 960px){
    .oc-unsubscribe-box{
      background-color:white ;
      padding: 6px 10px 20px 10px;
      margin: 20px 10px  10px 10px;

     /* width: 100%;
      position: absolute;
      display: block;*/
    }
    .oc-image{
      width: auto;
      height:20px;
    }
  }

</style>

